import {
  getVideoData,
  addVideoClick,
  getWebinarMenuList,
  getWebinarData,
  getWebinarDetail,
  saveSubscriber
} from '@/axios/api/introVideo'
import { Message } from 'element-ui'

const UPDATE_VIDEO_LIST = 'UPDATE_VIDEO_LIST'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_WEBINAR_LIST = 'UPDATE_WEBINAR_LIST'

const state = {
  videoList: [],
  total: 0,
  webinarMenu: [],
  webinarList: []
}

const getters = {
  videoList: state => state.videoList,
  total: state => state.total,
  webinarList: state => state.webinarList
}

const mutations = {
  [UPDATE_VIDEO_LIST] (state, videoList) {
    state.videoList = videoList
  },
  [UPDATE_TOTAL] (state, total) {
    state.total = total
  },
  [UPDATE_WEBINAR_LIST] (state, webinarList) {
    state.webinarList = webinarList
  }
}

const actions = {
  async getVideoListApi ({ commit }, params) {
    try {
      const res = await getVideoData(params)
      commit(UPDATE_VIDEO_LIST, res.data.records || [])
      commit(UPDATE_TOTAL, res.data.total)
    } catch (e) {

    }
  },
  async addVideoClickApi ({}, params) {
    try {
      await addVideoClick(params)
    } catch (e) {

    }
  },
  async getWebinarMenuListApi () {
    try {
      const res = await getWebinarMenuList()
      return res;
    } catch (e) {

    }
  },
  async getWebinarListApi ({ commit }, params) {
    try {
      const res = await getWebinarData(params)
      commit(UPDATE_WEBINAR_LIST, res.data.data || [])
      commit(UPDATE_TOTAL, res.data.total)
    } catch (e) {

    }
  },
  async getWebinarDetailApi ({ commit }, params) {
    try {
      const res = await getWebinarDetail({id: params})
      return res;
    } catch (e) {

    }
  },
  async saveSubscriberApi ({ commit }, params) {
    try {
      const res = await saveSubscriber(params)
      return res;
    } catch (e) {

    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/introVideo.js